/** Versión npm de `@mediapipe/tasks-vision`; debe coincidir con el CDN WASM. */
export const MEDIAPIPE_TASKS_VISION_VERSION = '0.10.35';

export const MEDIAPIPE_TASKS_VISION_WASM_CDN = `https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@${MEDIAPIPE_TASKS_VISION_VERSION}/wasm`;
